import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '../store/auth'
import PasswordInput from "../components/password.vue"
import { ref } from 'vue'
import { router } from '../router'


export default /*@__PURE__*/_defineComponent({
  __name: 'auth',
  setup(__props, { expose: __expose }) {
  __expose();

const email = ref<string>('')
const password = ref<string>('')
const error = ref<null | string>(null);
const auth = useAuth();

const login = async() =>{
    error.value = null

    try{
        const response = await auth.signIn(email.value, password.value)

        if(response.success){
            router.push('/')
        }else{
            error.value = response.reason
        }
    }catch(e) {
        if(typeof e === 'string'){
            error.value = e
        }else{
            error.value = e.message
        }
    }
}


const __returned__ = { email, password, error, auth, login, get useAuth() { return useAuth }, PasswordInput, ref, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})